// Add your custom JS here.
import Swiper from 'swiper/bundle';

const swiper = new Swiper('.swiper', {
    slidesPerView: 3,
    spaceBetween: 30,
    initialSlide: 1,
    watchOverflow: true,
    centeredSlides: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    breakpoints: {
        0 : {
            slidesPerView: 'auto',
            spaceBetween: 20,
        },
        420: {
            slidesPerView: 'auto',
            spaceBetween: 20,
        },
        775: {
            slidesPerView: 'auto',
            spaceBetween: 20,
        },
        1204: {
            slidesPerView: 'auto',
            spaceBetween: 20,
        },
        1440: {
            slidesPerView: 'auto',
            spaceBetween: 20,
        },
    }
})
//swiper.slideTo(1);


const testimonialSlider = new Swiper('.testimonial-slider', {
    grabCursor: true,
    effect: "creative",
    spaceBetween: 0,
    centeredSlides: true,
    autoplay: {
        delay: 10000,
        disableOnInteraction: false,
    },
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    creativeEffect: {
        prev: {
            shadow: true,
            translate: ["-20%", 0, -1],
        },
        next: {
            translate: ["100%", 0, 0],
        },
    },
});
// testimonialSlider.initialize();

